// Track page views
export const trackPageView = (path) => {
    if (window.gtag) {
        window.gtag('config', 'G-XH01WQFM0C', {
            page_path: path
        });
    }
};

// Track events
export const trackEvent = (eventName, params = {}) => {
  if (typeof window.gtag !== 'function') return;

  window.gtag('event', eventName, {
    ...params,
    cvr_length: params.cvr_number?.length || 0,  // Track CVR length
    cvr_value: params.cvr_number,                // Track actual CVR number
    timestamp: new Date().toISOString()
  });
};